// Befund 35 — zentraler QueryClient mit globalem Mutations-Fehler-Feedback.
// Bisher zeigten ~20 Mutations (Settings speichern, Stammdaten-Admin, Vorgänge …)
// bei einem API-Fehler gar nichts. Der MutationCache.onError toastet jetzt zentral —
// außer die Mutation behandelt Fehler selbst:
//   - Hook-eigenes onError (useMutation-Option) → still, oder
//   - meta.silenceGlobalError (Konvention für Aufrufer mit try/catch + eigenem
//     Toast/Banner, z. B. useVmCommand in VmList/VmDetail) → still.
// Achtung: per-Call-Callbacks (mutate(vars, { onError }) bzw. try/catch um
// mutateAsync) sieht der Cache NICHT — solche Hooks tragen das meta-Flag.
import { MutationCache, QueryClient } from '@tanstack/react-query'
import { ApiError } from '../api/client'
import { globalToastError } from './globalToast'

// Liest die deutsche Server-Fehlermeldung aus dem 4xx-Body ({ "error": "…" });
// sonst generische Meldung. Roh-Bodies (HTML, Stacktraces) nie anzeigen.
export function mutationErrorMessage(error: unknown): string {
  if (error instanceof ApiError && error.body) {
    try {
      const parsed = JSON.parse(error.body) as { error?: unknown }
      if (typeof parsed?.error === 'string' && parsed.error) return parsed.error
    } catch {
      /* Body ist kein JSON */
    }
  }
  return 'Aktion fehlgeschlagen.'
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: { queries: { staleTime: 15_000, retry: 1 } },
    mutationCache: new MutationCache({
      onError: (error, _variables, _context, mutation) => {
        if (mutation.options.onError != null) return
        if (mutation.meta?.silenceGlobalError === true) return
        globalToastError(mutationErrorMessage(error))
      },
    }),
  })
}
